import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: ${props => props.theme.colors.color5a6a7e};
`

export const GreetingMessage = styled.div`
  font: normal normal normal 24px Inter;
  color: ${props => props.theme.colors.color2d3139};
`

export const DoctorName = styled.span`
  font-weight: bold;
`

export const Title = styled.div`
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  color: ${props => props.theme.colors.color5a6a7e};
  font-family: 'Inter';
  font-size: 16px;
  line-height: 16px;
  font-weight: 400;

  b {
    font-weight: 600;
  }
`

export const ResultsQuantity = styled.span`
  color: ${props => props.theme.colors.color1f6ecd};
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
`

export const ClearSearchButton = styled.button`
  color: ${props => props.theme.colors.color1f6ecd};
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  text-decoration-line: underline;

  background: transparent;
  border: none;
  cursor: pointer;

  display: flex;
  align-items: center;
  gap: 4px;

  svg {
    fill: ${props => props.theme.colors.color1f6ecd};
  }
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
`

export const TableHeader = styled.thead`
  color: ${props => props.theme.colors.color5a6a7e};
  font-family: 'Inter';
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 100% */
`

export const TableBody = styled.tbody`
  color: ${props => props.theme.colors.color2d3139};
  font-family: 'Inter';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;

  & tr:nth-child(odd) {
    background: ${props => props.theme.colors.colorf3f5f9};
  }
  & tr {
    cursor: pointer;
  }

  & tr:hover {
    background: ${props => props.theme.colors.colore9edf2};
  }
`

export const TableRow = styled.tr`
  border-radius: 4px;
`

export const BlockedTableRow = styled.tr`
  border-radius: 4px;
  background: #f9f3f3 !important;
  cursor: not-allowed !important;

  &:hover {
    background: #f9f3f3 !important;
  }
`

export const TableCell = styled.td`
  padding: 0.5rem;
`
